import React from "react"

import { Badge, ColorSwatch, TruncatedText } from "@coval/ui"

import { getDefaultTagColor } from "../constants/tag-colors"

interface TagChipProps extends Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "color"
> {
  tag: string
  color?: string | null
  onRemove?: () => void
  colorControl?: React.ReactNode
}

export const TagChip = React.forwardRef<HTMLSpanElement, TagChipProps>(
  ({ tag, color, onRemove, colorControl, className, ...props }, ref) => {
    const resolvedColor = color || getDefaultTagColor(tag)

    return (
      <Badge
        ref={ref}
        size="chip"
        onDismiss={onRemove}
        className={`min-w-0 max-w-[160px] shrink overflow-hidden font-medium ${className ?? ""}`}
        {...props}
      >
        {colorControl ?? <ColorSwatch color={resolvedColor} />}
        <TruncatedText>{tag}</TruncatedText>
      </Badge>
    )
  },
)

TagChip.displayName = "TagChip"
